export default __webpack_public_path__ + "static/media/DACM.9de19111.svg";